module.exports = __webpack_public_path__ + "static/media/play.9d7b7d58.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/discordAssets/play.svg
// module id = 381
// module chunks = 17